import { createContext, useCallback, useContext, useRef, useState } from "react";

import { cn } from "@/lib/utils";

const ToastCtx = createContext(() => {});
export const useToast = () => useContext(ToastCtx);

const KIND = {
  info: "bg-foreground text-background",
  success: "bg-success text-white",
  error: "bg-destructive text-white",
};

export function ToastProvider({ children }) {
  const [toast, setToast] = useState(null);
  const timer = useRef(null);
  const show = useCallback((msg, kind = "info") => {
    if (timer.current) clearTimeout(timer.current);
    setToast({ id: Date.now(), msg, kind });
    timer.current = setTimeout(() => setToast(null), 3200);
  }, []);
  return (
    <ToastCtx.Provider value={show}>
      {children}
      <div aria-live="polite" className="pointer-events-none fixed inset-x-0 top-4 z-[100] flex justify-center px-4">
        {toast ? (
          <div key={toast.id} data-testid="toast"
            className={cn("fade-up w-full max-w-md rounded-xl px-5 py-4 shadow-2xl", KIND[toast.kind])}>
            <p className="text-[15px] font-medium" data-testid="toast-message">{toast.msg}</p>
          </div>
        ) : null}
      </div>
    </ToastCtx.Provider>
  );
}
